// Port of api/fuel/app/classes/filter/search/games/rules/query/comment_date.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'comment_date',
	field: function() { return 'm.comment_date' }
})
